module.exports = __webpack_public_path__ + "static/media/fe_1.6f8fe9e1.png";